import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { injectIntl } from "react-intl";

import { Callback, Logout, LogoutCallback, PrivateRoute } from './components';
import { SilentRenew } from './components/auth/SilentRenew';
import Fade from '@material-ui/core/Fade';

import Dashboard from './views/Dashboard';
import CustomDashboard from './views/CustomDashboards';
import SharedDashboards from './views/SharedDashboards'
import { Dashboard as DashboardLayout } from './layouts';
import Icons from './common/icons/Icons';

export class Routes extends Component {

    render() {
        return (
            <Fade>
                <Switch>
                    <Redirect exact from="/" to="/app" />
                    <Redirect exact from="/dashboard" to="/app" />
                    <Redirect exact from="/dashboard/:componentKey" to="/app" />
                    <Redirect exact from="/customdash" to="/app" />
                    <Redirect exact from="/shareddashboard" to="/app" />
                    
                    <Route exact component={Callback} path="/signin-oidc" />
                    <Route exact component={Logout} path="/logout" />
                    <Route exact component={LogoutCallback} path="/logout/callback" />
                    <Route exact component={SilentRenew} path="/silentrenew" />

                    <PrivateRoute exact component={Dashboard} path="/dashboard" />
                    <PrivateRoute exact component={Dashboard} path="/dashboard/:componentKey" />
                    <PrivateRoute exact component={CustomDashboard} path="/customdash" />
                    <PrivateRoute exact component={SharedDashboards} path="/shareddashboard" />

                    <PrivateRoute component={DashboardLayout} path='/app' />
                    <Route exact path="/icons" component={Icons} />
                </Switch>
            </Fade>
        );
    }

}
export default injectIntl(Routes);